import { JobStatusEnum } from '../../models/jobStatusEnum';
import { TransferStatusEnum } from '../../models/transferStatusEnum.enum';
import { DispoUser } from '../../models/user';

export function getDispoBookedTabJobsQuery(user: DispoUser): object {
  return {
    $or: [
      {
        $and: [
          {
            status: JobStatusEnum.CLOSED,
          },
          {
            transfers: {
              $elemMatch: {
                'targetCustomer.id': user.customerId,
                status: { $ne: TransferStatusEnum.ARCHIVED },
              },
            },
          },
        ],
      },
      {
        $and: [
          {
            status: JobStatusEnum.CLOSED,
          },
          {
            'transfers.targetCustomer.id': { $ne: user.customerId },
          },
        ],
      },
    ],
  };
}
